// extracted by mini-css-extract-plugin
export default {"editorControls":"editorControls_editorControls__0ihci"};